import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from '@config/app.config';
import { CustomersRepository } from '@core/repositories/customers.repository';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ApiCustomersRepository implements CustomersRepository {
  constructor(public appConfig: AppConfig, public http: HttpClient) {}

  getItems(): Observable<any> {
    return this.http.get('');
  }

  getItemId(typeIdentify: string, identify: string) {
    const data = {
      data: {
        attributes: {
          documentNumber: identify,
          documentType: typeIdentify
        },
        type: 'Customers'
      }
    };

    return this.http.post(
      this.appConfig.SERVICES.customers.findbydocument.url,
      data
    );
  }

  getTypeIdentify(): Observable<any> {
    const typeIdentify = {
      data: [
        {
          id: 'FS001',
          attributes: {
            name: 'Cédula de ciudadanía'
          }
        }
      ]
    };
    return of(typeIdentify);
  }
}
